import { RetailerService } from "../common/api.service";

const initialState = {};

const state = { ...initialState };

const getters = {};

const mutations = {};

const actions = {
  findRetailers(_, params) {
    return RetailerService.find(params).then(({ data }) => data);
  },
  getRetailer(_, id) {
    return RetailerService.get(id).then(({ data }) => data);
  },
  saveRetailer(_, {
    id, date, reseller, ...body
  }) {
    const request = id
      ? RetailerService.update(id, body)
      : RetailerService.create(body);

    return request.then(({ data }) => data);
  },
  deleteRetailer(_, id) {
    return RetailerService.delete(id).then(({ data }) => data);
  },
  findResellerRetailers(_, params) {
    return RetailerService.findResellerRetailers(params).then(({ data }) => data);
  },
  saveResellerRetailer(_, { id, date, ...body }) {
    const request = id
      ? RetailerService.updateResellerRetailer(id, body)
      : RetailerService.createResellerRetailer(body);

    return request.then(({ data }) => data);
  },
  deleteResellerRetailer(_, id) {
    return RetailerService.deleteResellerRetailer(id).then(({ data }) => data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
